import React, { HTMLAttributes, ReactElement } from 'react';
import classNames from 'classnames';
import { useSelector } from '@ecommerce/nest-ssr/common';

import Carousel from 'atomic/carousel/carousel';
import ReviewSlide from 'atomic/review-slide/review-slide';
import type { CompanyReviewInterface } from 'interfaces/company-review.interface';

import './main-reviews.scss';

const MainCompanyReviews: React.FC<HTMLAttributes<HTMLElement>> = (
    {
        className
    }
): ReactElement => {
    const mainReviewsClasses = classNames(className, 'main-reviews');
    const recentCompanyReviews: CompanyReviewInterface[] = useSelector(
        (state: { recentCompanyReviews: CompanyReviewInterface[]; }) => state.recentCompanyReviews
    );

    return (
        <Carousel className={mainReviewsClasses}>
            {
                recentCompanyReviews
                    .map(({ id, author, company, content, averageRating, createdAt }) => (
                        <ReviewSlide
                            key={id}
                            author={author}
                            product={company.name}
                            url={`/opinie/${company.slug}`}
                            description={content}
                            score={averageRating}
                            date={createdAt}
                        />
                    ))
            }
        </Carousel>
    );
};

export default MainCompanyReviews;
